export const ModalityType = ['ALL', 'CT', 'MR', 'CR', 'DR', 'DX', 'US', 'NM', 'PT', 'OT', 'MG'];
